<template>
  <div class="register">
    <section class="head-wrapper">
      <header class="head">
        <a class="logo-wrapper" href="/">
          <img src="./logo.jpg" alt="logo" width="180" height="40">
        </a>
        <p class="text-wrapper">已有账号？
          <router-link class="gotoLog" to="/log">返回登录></router-link>
        </p>
      </header>
    </section>
    <div class="content">
      <img class="left-img" src="./student_register.png" alt="学生注册" width="442" height="570">
      <div class="register-wrapper">
        <h2 class="title">学生注册</h2>
        <p class="sub-title">Student registration</p>
        <div class="row" ref="input1" style="margin-top: 34px;">
          <span class="left">学生姓名：</span>
          <input type="text"
                 @blur="check1"
                 class="input-box" v-model="uname"
                 placeholder="请填写姓名"
                 maxlength="18">
        </div>
        <div class="row" ref="input2">
          <span class="left">手机号码：</span>
          <input type="text"
                 @blur="check2"
                 class="input-box"
                 maxlength="11"
                 placeholder="请输入手机号码"
                 :value="integer"
                 @keyup="integerChange">
        </div>
        <div class="row" ref="input3">
          <span class="left">短信验证码:</span>
          <input type="text"
                 @blur="check3"
                 class="input-box"
                 v-model="code"
                 placeholder="请输入验证码"
                 maxlength="10">
          <span class="send" @click="send" v-if="!whetherSend">获取验证码</span>
          <span class="time" v-if="whetherSend">{{time + 's'}}</span>
        </div>
        <div class="row" ref="input4">
          <span class="left">设置密码：</span>
          <input type="password"
                 @blur="check4"
                 class="input-box" v-model="password"
                 placeholder="请输入6-18位字符"
                 maxlength="18">
        </div>
        <div class="row" ref="input5">
          <span class="left">确认密码：</span>
          <input type="password"
                 @blur="check5"
                 class="input-box"
                 placeholder="再次确认字符"
                 v-model="confirmPass"
                 maxlength="18">
        </div>
        <button class="next-btn" @click="register">注册</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal, saveSession, loadSession} from 'common/js/store.js';
  import md5 from 'js-md5'
  export default{
    data(){
      return {
        id: '',
        uname: '',
        inputInteger: '',
        code: '',          //用户输入的验证码
        whetherSend: false,      //表示是否点击了发送验证码
        time: 60, // 发送验证码倒计时
        password: '',
        confirmPass: '',
        loading: '',
      }
    },
    methods: {
      integerChange(e) {
        this.inputInteger = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      //学生姓名
      check1(){
        if (this.uname === '') {
          this.$refs.input1.className="row error";
          return false;
        }else{
          this.$refs.input1.className="row";
          return true;
        }
        this.$forceUpdate();
      },
      //手机号码
      check2(){
        if (this.integer.length !== 11) {
          this.$refs.input2.className="row error";
          return false;
        }else{
          this.$refs.input2.className="row";
          return true;
        }
        this.$forceUpdate();
      },
      //验证码
      check3(){
        if (this.code === '') {
          this.$refs.input3.className="row error";
          return false;
        }else{
          this.$refs.input3.className="row";
          return true;
        }
        this.$forceUpdate();
      },
      //密码
      check4(){
        if (this.password === '' || this.password.length < 6 || this.password.length > 18) {
          this.$refs.input4.className="row error";
          return false;
        }else{
          this.$refs.input4.className="row";
          return true;
        }
        this.$forceUpdate();
      },
      //重复密码
      check5(){
        if (md5(this.password) !== md5(this.confirmPass) || this.confirmPass==='') {
          this.$refs.input5.className="row error";
          return false;
        }else{
          this.$refs.input5.className="row";
          return true;
        }
        this.$forceUpdate();
      },
      //检查是否可以发送验证码
      send(){
//        if (this.integer.length !== 11) {
//          this.$message({
//            message: '请输入正确的手机号码!',
//            type: 'warning'
//          });
//          return;
//        }
        if(!this.check2()){
          return;
        }
        //检查用户手机是否已经注册
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'checkuserexist',
            mobile: this.integer,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            //isexist为true表示手机号码已经注册，为false表示未注册
            if (response.isexist) {
              this.$message({
                message: '该手机号码已经注册，请直接登录!',
                type: 'warning'
              });
            } else {
              //发送手机验证码
              this.sendMessage();
            }
          }
        }).catch((err) => {
        })
      },
      //发送验证码
      sendMessage(){
        this.whetherSend = true;
        let interval = window.setInterval(()=> {
          if ((this.time--) <= 0) {
            this.time = 60;
            this.whetherSend = false;
            window.clearInterval(interval);
          }
        }, 1000);
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'sendMessage',
            a: 'sendSms',
            mobile: this.integer,
            type: 0,
            identity: 2
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      register(){
//        if (this.uname === '') {
//          this.$message({
//            message: '请输入学生姓名',
//            type: 'warning'
//          });
//          return;
//        }
//        if (this.integer.length !== 11) {
//          this.$message({
//            message: '请输入正确的手机号码!',
//            type: 'warning'
//          });
//          return;
//        }
//        if (this.code === '') {
//          this.$message({
//            message: '请输入验证码',
//            type: 'warning'
//          });
//          return;
//        }
//        if (this.password === '' || this.password.length < 6 || this.password.length > 18) {
//          this.$message({
//            message: '请输入6-18位字符密码',
//            type: 'warning'
//          });
//          return;
//        }
//        if (md5(this.password) !== md5(this.confirmPass)) {
//          this.$message({
//            message: '两次输入的密码不一致',
//            type: 'warning'
//          });
//          return;
//        }
//        this.loading = this.$loading({
//          lock: true,
//          spinner: 'el-icon-loading',
//          background: 'rgba(0, 0, 0, 0.7)'
//        });
        for(let i=1;i<=5;i++){
          this['check'+i]();
        }
        if(!(this.check1()&&this.check2()&&this.check3()&&this.check4&&this.check5)){
          return;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'loginByMobile',
            mobile: this.integer,
            code: this.code,
            platform: 'web'
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('id', response.id);
            this.id = response.id;
            this.Updateuser();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
//            this.loading.close();
          }
        }).catch((err) => {
        })
      },
      Updateuser(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'updateuser',
            id: this.id,
            uname: this.uname,
            identity: 2,      //老师为1，学生为2
            password: md5(this.password)
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.userinfo();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      userinfo(){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'User',
            a: 'userinfo',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('userinfo', response);
            window.location.replace('/');
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      }
    },
    computed: {
      integer() {
        return this.inputInteger.replace(/[^\d]/g, '').replace(/^0/g, "");
      },
    },
    mounted(){
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .register
    height: 100%
    background: #ffffff url('./background.png') no-repeat center / cover
    .head-wrapper
      width: 100%
      background: #fff
      .head
        width: 1226px
        height: 80px
        margin: 0 auto
        background: #fff
        font-size: 0
        .logo-wrapper
          float: left;
          height: 43px;
          width: 192px;
          padding-top: 18px;
        .text-wrapper
          float: right
          height: 80px
          line-height: 80px
          font-size: 14px
          color: #333
          text-align: center
          .gotoLog
            color: #ff6700
    .content
      margin: 40px auto 0
      font-size: 0
      width: 1128px
      height: 570px
      .left-img
        float: left
      .register-wrapper
        float: left
        width: 686px
        height: 570px
        background: #fff
        .title
          padding-top: 38px;
          height: 42px
          line-height: 42px
          text-align: center;
          font-size: 30px
          color: #333
        .sub-title
          height: 16px
          line-height: 16px
          font-size: 14px
          color: #888888
          text-align: center
        .row
          margin: 38px 0 0 143px
          height: 34px
          position: relative
          &.error::after
            content: ' '
            display: inline-block
            position: absolute
            width: 16px
            height: 16px
            background: url('./hint-error.png') no-repeat center / 16px 16px
            top: 9px
            right: 117px
          .left
            float: left
            margin-right: 30px
            width: 84px
            height: 34px
            line-height: 34px
            color: #333
            font-size: 16px
            text-align: right
          .input-box
            padding-left: 16px
            width: 286px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #333
            border-bottom: 1px solid #ccc
            box-sizing: border-box
            position: relative
            &::-webkit-input-placeholder
              color: #ccc
          .send, .time
            position: absolute
            top: 6px
            right: 143px
            display: inline-block
            padding: 0 17px
            width: 80px
            height: 22px
            line-height: 22px
            text-align: center
            font-size: 16px
            border-left: 1px solid #ccc
          .send
            color: #ff6700
            cursor: pointer
          .time
            color: #333
        .next-btn
          margin: 30px auto 0
          display: block
          width: 188px
          height: 46px
          line-height: 46px
          text-align: center
          font-size: 16px
          color: #ffffff
          background #ff6700
          border-radius: 23px
</style>



// WEBPACK FOOTER //
// src/page/register/RegisterStudent.vue